<template>
  <div :class="`kvass-media-render-slider kvass-media-render-slider--${navigationPlacement}`">
    <slot name="overlay" />
    <transition name="fade" mode="in-out">
      <component
        :is="component"
        :value="current"
        v-bind="$attrs"
        :key="current.url"
        :loop="loop"
        :duration="duration"
        mode="slider"
        @ended="next"
        :caption-visibility="captionVisibility"
      />
    </transition>

    <template v-if="manualNavigation && value.length > 1">
      <button
        class="kvass-media-render-slider__navigation-button kvass-media-render-slider__navigation-button--left"
        @click="prev"
      >
        <FontAwesomeIcon icon="arrow-left" />
      </button>
      <button
        class="kvass-media-render-slider__navigation-button kvass-media-render-slider__navigation-button--right"
        @click="next"
      >
        <FontAwesomeIcon icon="arrow-right" />
      </button>
    </template>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Types from '../Types'

export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    duration: {
      type: Number,
      default: 4000,
    },
    manualNavigation: {
      type: Boolean,
      default: false,
    },
    navigationPlacement: {
      type: String,
      default: 'center',
      validator: val => ['center', 'bottom'].includes(val),
    },
    captionVisibility: {
      type: String,
      default: 'visible',
      validator: val => ['visible', 'hidden', 'hover'].includes(val),
    },
  },
  data() {
    return {
      currentIndex: 0,
      interval: null,
    }
  },
  computed: {
    component() {
      switch (this.current.type) {
        case 'youtube':
          return Types.Youtube
        case 'vimeo':
          return Types.Vimeo
        default:
          return Types.Image
      }
    },
    current() {
      return this.value[this.currentIndex] || {}
    },
    loop() {
      if (this.value.length !== 1) return this.$attrs.loop
      return true
    },
  },

  methods: {
    start() {
      this.stop()
      if (['youtube', 'vimeo'].includes(this.current.type)) return
      this.interval = setTimeout(() => this.next(), this.duration)
    },
    stop() {
      clearInterval(this.interval)
      this.interval = null
    },
    onEnter() {
      this.stop()
    },
    onLeave() {
      this.start()
    },
    next() {
      if (this.currentIndex === this.value.length - 1) this.currentIndex = 0
      else this.currentIndex++
      this.start()
    },
    prev() {
      if (this.currentIndex === 0) this.currentIndex = this.value.length - 1
      else this.currentIndex--
      this.start()
    },
  },
  mounted() {
    this.start()
  },
  components: {
    FontAwesomeIcon,
  },
}
</script>

<style lang="scss">
.kvass-media-render-slider {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;

  &__navigation-button {
    position: absolute;
    margin: 0;
    padding: 1rem 1.5rem;
    background-color: rgba(0, 0, 0, 0.3);
    backdrop-filter: blur(10px);
    color: white;
    cursor: pointer;
    pointer-events: initial;
    z-index: 10;

    svg {
      filter: drop-shadow(0 2px 1px rgba(0, 0, 0, 0.3));
    }

    &:hover,
    &:focus-visible {
      background-color: rgba(0, 0, 0, 0.4);
    }

    &:active {
      background-color: rgba(0, 0, 0, 0.5);
    }

    &--left {
      left: 0;
    }

    &--right {
      right: 0;
    }
  }

  /* Navigation placement */
  &--center {
    .kvass-media-render-slider__navigation-button {
      top: 50%;
      translate: 0 -50%;
    }
  }
  &--bottom {
    .kvass-media-render-slider__navigation-button {
      bottom: 1rem;
      right: 1rem;
      left: auto;

      &--left {
        translate: -100%;
      }
    }
  }

  .kvass-media-render-image {
    position: absolute;
    top: 0;
    left: 0;
    height: inherit;
    width: inherit;
  }

  iframe {
    overflow: hidden;
    pointer-events: none;

    z-index: 0;
    min-width: calc(16 / 9 * 100vh); // 16:9 aspect ratio
    height: calc(9 / 16 * 100vw) !important;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    position: absolute;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 500ms;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
}
</style>
